import { useState } from "react";

const SubsidiaryProductReadOnlyRow = ({ index, t, subsidiaryProductItem, handleDeleteClick, oddIdx, add, setError }) => {
	const [isSubmit, setIsSubmit] = useState(false);

	function submitComplete() {
		setIsSubmit(false);
	}

	function submitDelete(event, subsidiaryProductItem) {
		setError("");
		setIsSubmit(true);
		handleDeleteClick(event, subsidiaryProductItem, submitComplete);
	}

	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{subsidiaryProductItem.companyName}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{subsidiaryProductItem.productName}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{subsidiaryProductItem.status}</td>
			<td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 pe-none" : "btn btn-primary btn-block"} onClick={(event) => submitDelete(event, subsidiaryProductItem)}>
					{subsidiaryProductItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
			</td>
		</tr>
	)
}
export default SubsidiaryProductReadOnlyRow;